import isEnterOrSpace from '../../../../../helpers/isEnterOrSpace';


const getOpcoOptions = function getOpcoOptionsForDropdown(
  opcos,
  updateOpco,
) {
  if (!opcos || opcos.length === 0) {
    return [{
      id: 'location',
      key: 'empty',
      value: 'No options available',
    }];
  }
  return opcos.map((opco) => {
    let locationType = '';

    if (opco.questionOptions && opco.questionOptions.length) {
      [locationType] = opco.questionOptions;
    }
    return ({
      id: 'location',
      key: opco.region,
      value: opco.display,
      onKeyDown: event => isEnterOrSpace(event) && updateOpco({ location: opco, locationType }),
      onClick: () => updateOpco({ location: opco, locationType }),
    });
  });
};

export default getOpcoOptions;
